import { useNavigate } from "react-router-dom";
import { FramedAvatar } from "./RankFrame";
import { ChevronRight } from "lucide-react";

const RECENT_DAYS = 14;

// Gratulationsruta på startsidan: visas när en säsong precis avslutats eller en ny precis startat.
export default function SeasonBanner({ season }) {
  const navigate = useNavigate();
  const a = season?.latest_archive;
  if (!a || !a.winner) return null;
  const startedAt = season.started_at ? new Date(season.started_at).getTime() : 0;
  const recentlyStarted = startedAt && Date.now() - startedAt < RECENT_DAYS * 86400000;
  if (!season.closed && !recentlyStarted) return null;
  const w = a.winner;
  return (
    <button data-testid="season-banner" onClick={() => navigate("/sasonger")}
      className="w-full flex items-center gap-3 p-3.5 rounded-2xl bg-gradient-to-r from-amber-500/25 via-amber-500/10 to-transparent border border-amber-400/50 mb-4 text-left active:scale-[0.99] transition-transform">
      <FramedAvatar icon={w.icon} name={w.name} rank={1} size={44} />
      <div className="flex-1 min-w-0 ml-1">
        <div className="text-[11px] uppercase tracking-wider text-amber-300 font-mono">{season.closed ? `Säsong ${a.season} är slut` : `Säsong ${season.season} har startat`}</div>
        <div className="font-bold text-slate-100 font-display leading-tight">🏆 Grattis {w.name}!</div>
        <div className="text-xs text-slate-400">Mästare i säsong {a.season} · se pall och slutställning</div>
      </div>
      <ChevronRight className="w-4 h-4 text-amber-400 shrink-0" />
    </button>
  );
}
